/**
 * Operates on region studios for newrider/studio_list region dropdown and region google map functionality.
 * Handles studio filtering for each region, map redrawing, and region default behavior.
 *
 * @return api
 */
SC.studios_list = (function () {
  var api = {};
  var $newSoulContainer;

  var init = function () {
    $newSoulContainer = $('#new-to-soul-container');

    if (!$newSoulContainer.length) {
      return;
    }

    handlers();
    regionFilters();
    getStudiosGrid();
    dropdownRegion();

    if (!Modernizr.objectfit) {
      handleOldBrowsers();
    }

    $(window).on('load', function () {
      SC.geo_locate.initializeMap();
    });
  };

  /**
   * Filters studios upon selection of dropdown regions.
   * @returns {void}
   */
  var regionFilters = function () {
    // update active state
    var regionId = $('.newrider-experience__region-dropdown__button__title').data('region-id');

    regionId = (regionId === 'all' ? 0 : regionId);

    $('.region-select-row a').removeClass('active');
    $('.newrider-experience__region-dropdown-list .region-select-row li a[data-id="' + regionId + '"]').addClass('active');
  };

  /**
   * Gets Url to show region clicked, add go back ability
   * Updates studio list, and redraws map.
   * @returns {void}
   */
  var getStudiosGrid = function () {
    $('.newrider-experience__container .region-select-row a').on('click', function (e) {
      e.preventDefault();

      var $newSelectedRegion = $(this);
      var $changeRegionBtn = document.getElementById('newrider-region_button');
      var regionId = Number($newSelectedRegion.data('id'));
      var url = '/new-to-soul/' + (regionId === '0' ? 'all' : regionId) + '/partial/';
      var $selectedRegion = $newSelectedRegion;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'html',
        success: function (data) {
          // Update studio list
          $('.newrider-experience__studio-elements__studio-list__body').html(data);

          // UI update selected region and close menu
          $('.newrider-experience__region-dropdown__button__region').html($selectedRegion.html());
          $('.region-select-row a').removeClass('active');
          $($selectedRegion).addClass('active');
          $changeRegionBtn.focus();
          $changeRegionBtn.setAttribute('aria-expanded', 'false');

          // redraw map
          SC.geo_locate.initializeMap();

          /**
           * mParticle sendEvent - Click New Region - New To Soul Page
           * Handles a click to a new region in the Studios section on the new to soul page region dropdown.
           * Sends an mParticle event and a label for the GA event.
           *
           * GA event data:
           * Category: Navigation
           * Action: Click New Region
           * Label: New Rider
           */
          var location = 'New Rider';
          var eventData = {
            'Region Name': (regionId === 0) ? 'All Studios' : $selectedRegion.data('region-name'),
            'Location': location
          };
          SC.analytics.mp.sendEvent('Click New Region', 'navigation', eventData, location);
        },
        error: function () {
          confirmation(null, 'Oops! an error occurred while submitting your request. try that again!');
        }
      });
    });
  };

  /**
   * Handles clicking of region dropdown btn and region.
   * @returns {void}
   */
  var dropdownRegion = function () {
    var $changeRegionBtn = document.getElementById('newrider-region_button');
    var $regionList = document.getElementsByClassName('newrider-experience__region-dropdown-list')[0];
    var regionDropdownContainer = document.getElementsByClassName('newrider-experience__region-dropdown')[0];

    if ($changeRegionBtn !== null) {
      var regionBtnEvent = function (e) {
        e.stopPropagation();
        e.preventDefault();

        if (!$('.soul-container').hasClass('auth-open')) {
          $('header').toggleClass('header-position');
          $('body').scrollTop(0);
        }

        if ($regionList.classList.contains('block')) {
          $regionList.classList.remove('block');
          $('.instructors-header-options, .studios-header-options, .newrider-experience__region-dropdown').removeClass('full-height');
          $regionList.setAttribute('aria-hidden', 'true');
          $changeRegionBtn.setAttribute('aria-expanded', 'false');
        } else {
          $regionList.classList.add('block');

          // this toggled class allows the menu to be scrollable for mobile
          $('.instructors-header-options, .studios-header-options, .newrider-experience__region-dropdown').addClass('full-height');
          $regionList.removeAttribute('aria-hidden');
          $changeRegionBtn.setAttribute('aria-expanded', 'true');

          /**
           * mParticle sendEvent - Click Browsing Regions - New To Soul page.
           * Handles click to the regions dropdown in the Studios section of the New To Soul page.
           * Sends an mParticle event with a label for Google Analytics.
           *
           * GA Event info:
           * Category: Navigation
           * Action: Click Browsing Regions
           * Label: New Rider
           */
          var location = 'New Rider';
          var eventData = {
            'Location': location
          };
          SC.analytics.mp.sendEvent('Click Browsing Regions', 'navigation', eventData, location);

          setTimeout(function () {
            $regionList.getElementsByTagName('a')[1].focus();
          }, 0);
        }
      };

      $changeRegionBtn.addEventListener('click', regionBtnEvent);

      $regionList.addEventListener('focusout', function (e) {
        if (regionDropdownContainer.contains(e.relatedTarget)) {
          return;
        }

        $regionList.classList.remove('block');
        $changeRegionBtn.setAttribute('aria-expanded', 'false');
        $regionList.setAttribute('aria-hidden', 'true');
      });

      $('html').click(function () {
        $regionList.classList.remove('block');
        $('.instructors-header-options, .studios-header-options, .newrider-experience__region-dropdown').removeClass('full-height');
        $regionList.setAttribute('aria-hidden', 'true');
        $changeRegionBtn.setAttribute('aria-expanded', 'false');
      });
    }
  };

  /**
   * Handlers for hovering and clicking
   * @returns {void}
   */
  var handlers = function handlers() {
    /**
     * Handle a click on the links on New To Soul page
     * Call the handleScrollEvent method to scroll the page.
     */
    $newSoulContainer.on('click', '.button__base__standard', SC.utils.ui.handleScrollEvent);

    /**
     * Handle New To Soul Back to Top button click.
     */
    $('#newrider-experience__back-to-top__button').on('click keyup', function (e) {
      e.preventDefault();

      if (!SC.utils.ui.handleKeyupEvent(e)) {
        return;
      }

      $('html, body').animate({
        scrollTop: 0
      }, 500);

      /**
       * mParticle logEvent - Click Back to Top - New to Soul page.
       */
      SC.analytics.mp.logEvent('Click Back to Top', 'navigation', {'Location': 'New Rider'});
    });

    /**
     * mParticle log Events - Link Clicks on the New To Soul main content section.
     */
    $('#nrf-learn-more-button').on('click', function () {
      SC.analytics.mp.logEvent('Click Learn More', 'navigation', {'Location': 'New Rider'});
    });

    $('#nrf-start-now-button').on('click', function () {
      SC.analytics.mp.logEvent('Click Start Now', 'navigation', {'Location': 'New Rider'});
    });

    $('#nrf-book-a-bike-button').on('click', function () {
      SC.analytics.mp.logEvent('Click Book A Bike', 'navigation', {'Location': 'New Rider'});
    });

    $('#nfr-get-to-know-them-button').on('click', function () {
      SC.analytics.mp.logEvent('Click Get to Know Them', 'navigation', {'Location': 'New Rider'});
    });

    $('#nrf-get-connected-button').on('click', function () {
      SC.analytics.mp.logEvent('Click Get Connected', 'navigation', {'Location': 'New Rider'});
    });

    /**
     * mParticle sendEvent - Click Studio Page - New To Soul Page Studio List
     * Sends an mParticle event with a label for Google Analytics.
     *
     * GA Event info:
     * Category: Navigation
     * Action: Click Studio Page
     * Label: New Rider
     */
    $newSoulContainer.on('click', '.newrider-experience__studio-wrapper__studio-link-wrapper .button__base', function (e) {
      var $link = $(e.target);
      var location = 'New Rider';
      var eventData = {
        'Studio Name': $link.data('studio-title'),
        'Context': $link.data('context'),
        'Location': location
      };

      SC.analytics.mp.sendEvent('Click Studio Page', 'navigation', eventData, location);
    });
  };

  /**
   * Function that makes HTML/CSS updates when user is on IE 11.
   * 1. It takes img HTMLs and makes the src the background-image URL
   * 2. It makes the images opacity 0.
   * 3. It adds the class is-old-browser to update CSS for necessary elements.
   * @returns {void}
   */
  var handleOldBrowsers = function handleOldBrowsers() {
    $('.new-to-soul__section__instructors-list-item').each(function () {
      var $container = $(this);
      var $img = $container.find('img');
      var imgUrl = $img.prop('src');

      if (imgUrl) {
        $container
          .css('background-image', 'url(' + imgUrl + ')')
          .addClass('is-old-browser');
        $img.css('opacity', 0);
      }
    });

    $('.new-to-soul__section__landing-background').addClass('is-old-browser');
    $('.new-to-soul__section__classes-description').addClass('is-old-browser');
    $('.new-to-soul__section__people-description').addClass('is-old-browser');
    $('.new-to-soul__section__experience-description').addClass('is-old-browser');
  };

  init();
  return api;
})();
